import React, { useCallback } from 'react';

import { useProcessAsync } from '@gogame/hooks-ts';

import { useBatchAddPromoCode } from 'scenes/Influencers/InfluencersCampaigns/data';
import { loadPromoCodes } from 'scenes/Influencers/InfluencersCampaigns/sources/influencersCampaigns';
import { AddPromoCodeForm } from 'scenes/PromoCodes/components/AddPromoCodeForm';

const InfluencerAddPromoCodeForm = ({
  initialValues,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [loading, processAsync] = useProcessAsync();
  const batchAddPromoCode = useBatchAddPromoCode(processAsync);

  const handleSubmit = useCallback(
    async ({ ids, promoCodeId }) => {
      await batchAddPromoCode({
        influencerCampaignIds: ids,
        promoCodeId,
      });
      onSubmit();
    },
    [processAsync]
  );

  return (
    <AddPromoCodeForm
      title={'Influencers Campaigns'}
      initialValues={initialValues}
      loading={loading}
      onClose={onClose}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      onLoadPromoCodes={loadPromoCodes}
    />
  );
};
export default InfluencerAddPromoCodeForm;
